import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import configureStore from "./store/store";
import {Provider} from "react-redux";

import {positions, Provider as AlertProvider, transitions} from "react-alert";
import AlertTemplate from "./components/alert";

const options = {
  position: positions.TOP_CENTER,
  timeout: 5000,
  offset: "30px",
  transition: transitions.SCALE,
  // z-index acima do modal do react-bootstrap (~1055); sem isso o alerta fica atrás do modal
  containerStyle: { zIndex: 9999 },
};

ReactDOM.render(
  <Provider store={configureStore}>
    <AlertProvider template={AlertTemplate} {...options}>
      <App/>
    </AlertProvider>
  </Provider>,
  document.getElementById("root")
);
